/**
 * TanStack Query hooks for `pdf-csv-invoice-export`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	pdfCsvInvoiceExportQueryKeys,
	type CreatePdfCsvInvoiceExportBody,
	type ListPdfCsvInvoiceExportResponse,
	type PdfCsvInvoiceExportRow,
} from "./api";

export function usePdfCsvInvoiceExportList(): UseQueryResult<ListPdfCsvInvoiceExportResponse, Error> {
	return useQuery({
		queryKey: pdfCsvInvoiceExportQueryKeys.list(),
		queryFn: list,
	});
}

export function usePdfCsvInvoiceExportCreate(): UseMutationResult<PdfCsvInvoiceExportRow, Error, CreatePdfCsvInvoiceExportBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pdfCsvInvoiceExportQueryKeys.all });
		},
	});
}

export function usePdfCsvInvoiceExportDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: pdfCsvInvoiceExportQueryKeys.all });
		},
	});
}
